<template>
    <i :class="classes">
        <slot></slot>
    </i>
</template>
<script>
    import theme from './fontIcon.scss'

    export default {
        name: 'font-icon',
        props: {
            disabled: Boolean,
            small: Boolean,
            regular: Boolean,
            danger: Boolean,
            white: Boolean,
            inherit: Boolean,
            green: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    'material-icons': true,
                    [this.theme.icon]: true,
                    [this.theme.regular]: this.regular,
                    [this.theme.isSmall]: this.small,
                    [this.theme.isWhite]: this.white,
                    [this.theme.isDisabled]: this.disabled,
                    [this.theme.isDanger]: this.danger,
                    [this.theme.isInherit]: this.inherit,
                    [this.theme.isGreen]: this.green,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FontIcon.vue?e1d99a5e